import { render } from "./VisionSection.vue?vue&type=template&id=65ebe19e&scoped=true"
import script from "./VisionSection.vue?vue&type=script&lang=js"
export * from "./VisionSection.vue?vue&type=script&lang=js"

import "./VisionSection.vue?vue&type=style&index=0&id=65ebe19e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ebe19e"]])

export default __exports__